<template>
  <div class="ReadComp">  
    <div ref="container" class="ReadComp__container" v-html="$root.reading"/>   
    <div ref="block" class="Bottom"> 
      <div class="ReadComp__button"> 
        <div class="Button" @click="onClick()">
          {{ trans('GLOBAL.close') }}
        </div>
      </div> 
    </div>
  </div> 
</template>

<script>

import gsap from "gsap"


export default {

  name: 'ReadComp',
  components: {},
  
  mounted() {

    this.$nextTick(()=>{

      gsap.from([ this.$el, this.$refs.container ], {
        duration: .25, 
          opacity: 0,
          stagger: .6,
          ease: 'none'
      })

      gsap.from([ this.$refs.block ], {
        duration: .5, 
          y: '+=400%', 
          ease: 'cubic.out', 
          stagger: .2,
          delay: .75, 
      })
    })

  },
  methods:{

    onClick() {
      gsap.to([ this.$refs.block, this.$el,  ], {
        duration: .25, 
          opacity: 0,
          stagger: .5,
          ease: 'none',
          onComplete: ()=>{ this.$parent.use_exemple = false }
      })
    },

  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.ReadComp
  position absolute
  top 0
  left 0
  color white
  width 100%
  height 100%
  display flex 
  flex-direction column
  justify-content space-between
  align-items center
  background rgb(78, 60, 153)
  background linear-gradient(0deg, rgba(78, 60, 153, .9) 40%, rgba(32, 37, 42, .9) 100%)
  z-index 30000

  &__container
    width 76%
    height 82%
    display flex 
    justify-content center
    align-items center
    text-align center
    line-height 1.25em

  &__button 
    position relative
    width 100%
    display flex
    justify-content center

</style>


